// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/denr logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/UserDash/UserDash.css */
.user-dash-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Header Styles */
.user-dash-header {
  display: flex;
  align-items: center;
  padding: 1rem;
  background-color: #023e8a; /* Updated header color as specified */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
  color: white; /* Added for better visibility against dark background */
}

.user-dash-logo {
  width: 50px;
  height: 50px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); 
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 1rem;
  border-radius: 50%;
}

.user-dash-org h1 {
  margin: 0;
  font-size: 1.5rem;
  color: white; /* Updated for better visibility against dark background */
  font-weight: 600;
}

.user-dash-org p {
  margin: 0;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.8); /* Updated for better visibility against dark background */
}

/* Content Layout */
.user-dash-content {
  display: flex;
  flex: 1 1;
}

/* Main Content Area */
.user-dash-main {
  flex: 1 1;
  padding: 1.5rem;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
}
.user-dash-main--center {
  flex: 1 1;
  padding: 1.5rem;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.user-dash-title {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: #333;
  font-weight: 600;
}

.user-dash-announcement {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  transition: all 0.3s;
}

.user-dash-announcement:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.user-dash-announcement-header {
  background-color: #4CAF50;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-dash-announcement-header h3 {
  margin: 0;
  color: white;
  font-weight: 500;
}

.user-dash-bell {
  width: 35px;
  height: 35px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-dash-bell i {
  color: white;
}

.user-dash-announcement-content {
  padding: 1.5rem;
}

.user-dash-announcement-content p {
  margin: 0 0 1rem 0;
  line-height: 1.6;
  color: #333;
}
/* Add this to your UserDash.css file */
.dashboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

.dashboard-header h2 {
  margin: 0;
}

.tracking-code {
  font-size: 1rem;
  color: #333;
}

/* Button styles */
.action-button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
}

.action-button i {
  margin-right: 0.5rem;
}

.view-button {
  background-color: #3498db;
  color: white;
}

.view-button:hover {
  background-color: #2980b9;
  transform: translateY(-2px);
}

.close-button {
  background-color: #f44336;
  color: white;
}

.close-button:hover {
  background-color: #d32f2f;
  transform: translateY(-2px);
}
.status-button {
  background-color: #2ecc71;
}
.status-button:hover {
  background-color: #27ae60;
}
/* Status badges */
.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-right: 0.5rem;
  display: inline-block;
}

.status-passed {
  background-color: rgba(76, 175, 80, 0.1);
  color: #388e3c;
  border: 1px solid #4CAF50;
}

.status-failed {
  background-color: rgba(244, 67, 54, 0.1);
  color: #d32f2f;
  border: 1px solid #f44336;
}
.status-check-button {
  background-color: #f39c12;
}

.status-check-button:hover {
  background-color: #e67e22;
}

/* Responsive design */
@media (max-width: 768px) {
  .user-dash-content {
    flex-direction: column;
  }
  
  .user-dash-main {
    padding: 1rem;
  }
}

/* Style for printing */
@media print {
  .a4-container {
      width: 210mm;
      height: auto;
      margin: 0 auto;
      padding: 15mm;
      box-sizing: border-box;
      font-family: Arial, sans-serif;
  }

  /* Print-specific adjustments */
  .tracking-content {
      width: 100%;
      margin: 0;
      padding: 0;
  }

  .tracking-container p,
  .tracking-container h3,
  .tracking-container h4 {
      margin-bottom: 8px;
  }

  .tracking-container p {
      font-size: 12pt;
      line-height: 1.5;
  }

  .tracking-container h3 {
      font-size: 14pt;
      font-weight: bold;
  }

  .tracking-container h4 {
      font-size: 13pt;
      font-weight: bold;
  }

  .tablediv {
      page-break-inside: avoid; /* Prevent page breaks inside each table section */
      margin-bottom: 20px; /* Add some space between sections */
  }
  .json-table {
      width: 100%; /* Ensure tables take full width */
      border-collapse: collapse; /* Collapse borders for better printing */
  }

  .json-table th, .json-table td {
      border: 1px solid #ddd; /* Add borders for table cells */
      padding: 2px; /* Add padding for table cells */
      word-wrap: break-word; /* Allow long words to break */
  }

  .buttoncontainerzz{
      display: none;
  }

  .print-permit {
    scale: 1.5;
  }
  .user-dash-header{
    display: none;
  }
}

/* Application Management Component Styles */

/* Main container */
.application-container {
  background-color: #fff;
  border-radius: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 20px 30px;
  margin: 0;
  font-family: Arial, sans-serif;
}

/* Heading */
.application-container h2 {
  color: #000;
  font-size: 24px;
  margin-bottom: 24px;
  font-weight: 600;
}

/* Application info */
.application-info {
  margin-top: 10px;
}

.application-info p {
  font-size: 16px;
  margin-bottom: 5px;
}

.application-info p strong {
  font-weight: 700;
  letter-spacing: 0;
}

/* Tracking code formatting */
.application-info strong {
  font-family: monospace;
}

/* Status section title */
.application-status {
  margin: 20px 0;
  padding: 0;
  background-color: transparent;
  border: none;
}

.application-status h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #000;
}

/* Status items */
.status-item {
  display: flex;
  padding: 5px 0;
  border-bottom: none;
}

/* Status labels and values formatting */
.status-label {
  font-weight: 600;
  color: #000;
  margin-right: 5px;
}

.status-label:after {
  content: ":";
}

.status-value {
  color: #000;
}

/* Button container */
.application-actions {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

/* View Application button */
.application-button {
  padding: 8px 15px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.application-button:hover {
  background-color: #2980b9;
}
/* Icon in button */
.action-buttons {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}
.action-button {
  padding: 8px 15px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.view-button {
  background-color: #3498db;
}
.view-button:hover {
  background-color: #2980b9;
}
.approval-status-button {
  background-color: #2e31cc;
}

.approval-status-button:hover {
  background-color: #4e7bf5;
}
.dashboard-action-buttons {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/UserDashboard/UserDash.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,4DAA4D;AAC9D;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB,EAAE,sCAAsC;EACjE,wCAAwC;EACxC,WAAW;EACX,YAAY,EAAE,wDAAwD;AACxE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yDAAgD;EAChD,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,YAAY,EAAE,0DAA0D;EACxE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,+BAA+B,EAAE,0DAA0D;AAC7F;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAO;AACT;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,SAAO;EACP,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA,kBAAkB;AAClB;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,uBAAuB;AACvB;EACE;MACI,YAAY;MACZ,YAAY;MACZ,cAAc;MACd,aAAa;MACb,sBAAsB;MACtB,8BAA8B;EAClC;;EAEA,+BAA+B;EAC/B;MACI,WAAW;MACX,SAAS;MACT,UAAU;EACd;;EAEA;;;MAGI,kBAAkB;EACtB;;EAEA;MACI,eAAe;MACf,gBAAgB;EACpB;;EAEA;MACI,eAAe;MACf,iBAAiB;EACrB;;EAEA;MACI,eAAe;MACf,iBAAiB;EACrB;;EAEA;MACI,wBAAwB,EAAE,kDAAkD;MAC5E,mBAAmB,EAAE,oCAAoC;EAC7D;EACA;MACI,WAAW,EAAE,kCAAkC;MAC/C,yBAAyB,EAAE,yCAAyC;EACxE;;EAEA;MACI,sBAAsB,EAAE,gCAAgC;MACxD,YAAY,EAAE,gCAAgC;MAC9C,qBAAqB,EAAE,8BAA8B;EACzD;;EAEA;MACI,aAAa;EACjB;;EAEA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA,4CAA4C;;AAE5C,mBAAmB;AACnB;EACE,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,SAAS;EACT,8BAA8B;AAChC;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,UAAU;EACV,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;AACA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB","sourcesContent":["/* src/components/UserDash/UserDash.css */\r\n.user-dash-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n\r\n/* Header Styles */\r\n.user-dash-header {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 1rem;\r\n  background-color: #023e8a; /* Updated header color as specified */\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  z-index: 10;\r\n  color: white; /* Added for better visibility against dark background */\r\n}\r\n\r\n.user-dash-logo {\r\n  width: 50px;\r\n  height: 50px;\r\n  background-image: url('../images/denr logo.png'); \r\n  background-size: contain;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  margin-right: 1rem;\r\n  border-radius: 50%;\r\n}\r\n\r\n.user-dash-org h1 {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  color: white; /* Updated for better visibility against dark background */\r\n  font-weight: 600;\r\n}\r\n\r\n.user-dash-org p {\r\n  margin: 0;\r\n  font-size: 0.8rem;\r\n  color: rgba(255, 255, 255, 0.8); /* Updated for better visibility against dark background */\r\n}\r\n\r\n/* Content Layout */\r\n.user-dash-content {\r\n  display: flex;\r\n  flex: 1;\r\n}\r\n\r\n/* Main Content Area */\r\n.user-dash-main {\r\n  flex: 1;\r\n  padding: 1.5rem;\r\n  background-color: #f9f9f9;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.user-dash-main--center {\r\n  flex: 1;\r\n  padding: 1.5rem;\r\n  background-color: #f9f9f9;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.user-dash-title {\r\n  margin-top: 0;\r\n  margin-bottom: 1.5rem;\r\n  color: #333;\r\n  font-weight: 600;\r\n}\r\n\r\n.user-dash-announcement {\r\n  background-color: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n  overflow: hidden;\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n  width: 100%;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.user-dash-announcement:hover {\r\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.user-dash-announcement-header {\r\n  background-color: #4CAF50;\r\n  padding: 1rem;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.user-dash-announcement-header h3 {\r\n  margin: 0;\r\n  color: white;\r\n  font-weight: 500;\r\n}\r\n\r\n.user-dash-bell {\r\n  width: 35px;\r\n  height: 35px;\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.user-dash-bell i {\r\n  color: white;\r\n}\r\n\r\n.user-dash-announcement-content {\r\n  padding: 1.5rem;\r\n}\r\n\r\n.user-dash-announcement-content p {\r\n  margin: 0 0 1rem 0;\r\n  line-height: 1.6;\r\n  color: #333;\r\n}\r\n/* Add this to your UserDash.css file */\r\n.dashboard-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.dashboard-header h2 {\r\n  margin: 0;\r\n}\r\n\r\n.tracking-code {\r\n  font-size: 1rem;\r\n  color: #333;\r\n}\r\n\r\n/* Button styles */\r\n.action-button {\r\n  padding: 0.75rem 1.5rem;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n  font-size: 0.9rem;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.action-button i {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.view-button {\r\n  background-color: #3498db;\r\n  color: white;\r\n}\r\n\r\n.view-button:hover {\r\n  background-color: #2980b9;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.close-button {\r\n  background-color: #f44336;\r\n  color: white;\r\n}\r\n\r\n.close-button:hover {\r\n  background-color: #d32f2f;\r\n  transform: translateY(-2px);\r\n}\r\n.status-button {\r\n  background-color: #2ecc71;\r\n}\r\n.status-button:hover {\r\n  background-color: #27ae60;\r\n}\r\n/* Status badges */\r\n.status-badge {\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 20px;\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  margin-right: 0.5rem;\r\n  display: inline-block;\r\n}\r\n\r\n.status-passed {\r\n  background-color: rgba(76, 175, 80, 0.1);\r\n  color: #388e3c;\r\n  border: 1px solid #4CAF50;\r\n}\r\n\r\n.status-failed {\r\n  background-color: rgba(244, 67, 54, 0.1);\r\n  color: #d32f2f;\r\n  border: 1px solid #f44336;\r\n}\r\n.status-check-button {\r\n  background-color: #f39c12;\r\n}\r\n\r\n.status-check-button:hover {\r\n  background-color: #e67e22;\r\n}\r\n\r\n/* Responsive design */\r\n@media (max-width: 768px) {\r\n  .user-dash-content {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .user-dash-main {\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n/* Style for printing */\r\n@media print {\r\n  .a4-container {\r\n      width: 210mm;\r\n      height: auto;\r\n      margin: 0 auto;\r\n      padding: 15mm;\r\n      box-sizing: border-box;\r\n      font-family: Arial, sans-serif;\r\n  }\r\n\r\n  /* Print-specific adjustments */\r\n  .tracking-content {\r\n      width: 100%;\r\n      margin: 0;\r\n      padding: 0;\r\n  }\r\n\r\n  .tracking-container p,\r\n  .tracking-container h3,\r\n  .tracking-container h4 {\r\n      margin-bottom: 8px;\r\n  }\r\n\r\n  .tracking-container p {\r\n      font-size: 12pt;\r\n      line-height: 1.5;\r\n  }\r\n\r\n  .tracking-container h3 {\r\n      font-size: 14pt;\r\n      font-weight: bold;\r\n  }\r\n\r\n  .tracking-container h4 {\r\n      font-size: 13pt;\r\n      font-weight: bold;\r\n  }\r\n\r\n  .tablediv {\r\n      page-break-inside: avoid; /* Prevent page breaks inside each table section */\r\n      margin-bottom: 20px; /* Add some space between sections */\r\n  }\r\n  .json-table {\r\n      width: 100%; /* Ensure tables take full width */\r\n      border-collapse: collapse; /* Collapse borders for better printing */\r\n  }\r\n\r\n  .json-table th, .json-table td {\r\n      border: 1px solid #ddd; /* Add borders for table cells */\r\n      padding: 2px; /* Add padding for table cells */\r\n      word-wrap: break-word; /* Allow long words to break */\r\n  }\r\n\r\n  .buttoncontainerzz{\r\n      display: none;\r\n  }\r\n\r\n  .print-permit {\r\n    scale: 1.5;\r\n  }\r\n  .user-dash-header{\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Application Management Component Styles */\r\n\r\n/* Main container */\r\n.application-container {\r\n  background-color: #fff;\r\n  border-radius: 0;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  padding: 20px 30px;\r\n  margin: 0;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n/* Heading */\r\n.application-container h2 {\r\n  color: #000;\r\n  font-size: 24px;\r\n  margin-bottom: 24px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Application info */\r\n.application-info {\r\n  margin-top: 10px;\r\n}\r\n\r\n.application-info p {\r\n  font-size: 16px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.application-info p strong {\r\n  font-weight: 700;\r\n  letter-spacing: 0;\r\n}\r\n\r\n/* Tracking code formatting */\r\n.application-info strong {\r\n  font-family: monospace;\r\n}\r\n\r\n/* Status section title */\r\n.application-status {\r\n  margin: 20px 0;\r\n  padding: 0;\r\n  background-color: transparent;\r\n  border: none;\r\n}\r\n\r\n.application-status h3 {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  margin-bottom: 15px;\r\n  color: #000;\r\n}\r\n\r\n/* Status items */\r\n.status-item {\r\n  display: flex;\r\n  padding: 5px 0;\r\n  border-bottom: none;\r\n}\r\n\r\n/* Status labels and values formatting */\r\n.status-label {\r\n  font-weight: 600;\r\n  color: #000;\r\n  margin-right: 5px;\r\n}\r\n\r\n.status-label:after {\r\n  content: \":\";\r\n}\r\n\r\n.status-value {\r\n  color: #000;\r\n}\r\n\r\n/* Button container */\r\n.application-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 15px;\r\n}\r\n\r\n/* View Application button */\r\n.application-button {\r\n  padding: 8px 15px;\r\n  background-color: #3498db;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-weight: 500;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.application-button:hover {\r\n  background-color: #2980b9;\r\n}\r\n/* Icon in button */\r\n.action-buttons {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 15px;\r\n}\r\n.action-button {\r\n  padding: 8px 15px;\r\n  background-color: #3498db;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-weight: 500;\r\n  transition: background-color 0.2s;\r\n}\r\n.view-button {\r\n  background-color: #3498db;\r\n}\r\n.view-button:hover {\r\n  background-color: #2980b9;\r\n}\r\n.approval-status-button {\r\n  background-color: #2e31cc;\r\n}\r\n\r\n.approval-status-button:hover {\r\n  background-color: #4e7bf5;\r\n}\r\n.dashboard-action-buttons {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 15px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
